import { uncapitalize } from '@attain-apps/string-utils'

import * as core from '../../../../../../core'
import * as common from '../../../../../common'

import * as libraryUserCategory from './library-user-category'

// NOTE: everything below is designed to simulate a normal folder/module
// structure for exporting resources from separate files. This just simply
// generates those resources based on the known enum entries

const enumId = core.dms.models.Enum.Id.from({
  partialId: libraryUserCategory.RESOURCE.payload.partialId,
})

const enumEntryResourceNameLookup = {} as Record<
  common.LibraryUserCategory,
  string
>
for (const enumEntryName in common.LibraryUserCategory) {
  const potentialEnum =
    common.LibraryUserCategory[
      enumEntryName as keyof typeof common.LibraryUserCategory
    ]
  if (common.LibraryUserCategory.isLibraryUserCategory(potentialEnum)) {
    enumEntryResourceNameLookup[potentialEnum] = uncapitalize(enumEntryName)
  }
}

export const entries = common.LibraryUserCategory.ALL.reduce(
  (prev, _libraryUserCategory) =>
    Object.assign(prev, {
      [enumEntryResourceNameLookup[_libraryUserCategory]]: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        RESOURCE: {
          payload: {
            ...common.LibraryUserCategory.getEntry(_libraryUserCategory),
            enumId,
          },
          type: core.quiver.Resource.Type.DmsEnumEntry,
        } as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>,
      },
    }),
  {} as {
    [K in keyof typeof common.LibraryUserCategory as (typeof common.LibraryUserCategory)[K] extends common.LibraryUserCategory
      ? Uncapitalize<K>
      : never]: {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      RESOURCE: core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
    }
  },
)
